// season-info.js — Saison eines Platzes aus spots.season (OSM opening_hours bzw. „Ganzjährig“). Gemeinsam für App (Abzeichen
// in Entdecken, src/shared/spot-status.js) und Verwaltung (Anrufmodus, src/admin/lib/season.js re-exportiert).
// Erkannt werden nur Monatsbereiche wie „Apr-Oct“, „Apr 1 - Oct 31“, „Nov-Mar“. Alles andere
// (Uhrzeiten, Freitext) ist „unbekannt“ — nie „geschlossen“, sonst würde ein Platz zu Unrecht
// im Anrufmodus nach hinten sortiert.

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DE = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
const RANGE = /^\s*([A-Z][a-z]{2})\s*(\d{1,2})?\s*-\s*([A-Z][a-z]{2})\s*(\d{1,2})?/;
const lastDay = (m) => new Date(2025, m + 1, 0).getDate(); // 2025: kein Schaltjahr — 28. Feb. als Ende reicht

/**
 * @param {string|null} season
 * @param {Date} date
 * @returns {{ state: 'ganzjaehrig'|'offen'|'geschlossen'|'unbekannt', label: string, opens?: string }}
 */
export function seasonInfo(season, date = new Date()) {
  const s = String(season || '').trim();
  if (/^ganzj(ä|ae)hrig/i.test(s)) return { state: 'ganzjaehrig', label: 'ganzjährig' };
  // OSM-Ausnahmen („Nov-Mar off“, „Dec 24-Dec 26 closed“) beschreiben Schließzeiten — lieber unbekannt als falsch herum.
  if (/\b(off|closed)\b/i.test(s)) return { state: 'unbekannt', label: 'Saison unbekannt' };
  const m = RANGE.exec(s);
  const m1 = m ? MONTHS.indexOf(m[1]) : -1, m2 = m ? MONTHS.indexOf(m[3]) : -1;
  if (m1 < 0 || m2 < 0) return { state: 'unbekannt', label: 'Saison unbekannt' };
  const d1 = m[2] ? Math.min(+m[2], lastDay(m1)) : 1;
  const d2 = m[4] ? Math.min(+m[4], lastDay(m2)) : lastDay(m2);
  const start = m1 * 100 + d1, end = m2 * 100 + d2;
  if (start === 1 && end === 1131) return { state: 'ganzjaehrig', label: 'ganzjährig' };
  const today = date.getMonth() * 100 + date.getDate();
  const open = start <= end ? today >= start && today <= end : today >= start || today <= end;
  return open ? { state: 'offen', label: 'geöffnet bis ' + DE[m2] } : { state: 'geschlossen', label: 'geschlossen bis ' + DE[m1], opens: DE[m1] };
}

/** Sortierrang für den Anrufmodus: geöffnete zuerst, geschlossene zuletzt. */
export function seasonRank(info) {
  return info && info.state === 'geschlossen' ? 2 : info && info.state === 'unbekannt' ? 1 : 0;
}
